import React, { useEffect, useState } from "react";
import { Grid, GridRow, GridColumn, SearchBox, Stack, ClearFiltersButton, ListTable } from "sprint-common-web";

import { useCatalogueBuzzApi } from "../../../common/api/catalogue-api/buzz/useCatalogueBuzzApi";
import { createLookupContentListTableColumns } from "./createLookupContentListColumns";
import { LookupContentItem, mapToLookupContentItem } from "./LookupContentItem";

interface LookupContentListProps {
    onClick: (item: LookupContentItem) => void;
}

export const LookupContentList = ({ onClick }: LookupContentListProps): JSX.Element => {
    const { getContentByBuzzId } = useCatalogueBuzzApi();

    const [items, setItems] = useState<LookupContentItem[]>([]);
    const [isLoadingList, setIsLoadingList] = useState(false);
    const [filters, setFilters] = useState({
        buzzId: ""
    });

    useEffect(() => {
        setIsLoadingList(true);
        getContentByBuzzId(filters)
            .then((res) => {
                setItems(res.items.map(mapToLookupContentItem));
            })
            .finally(() => {
                setIsLoadingList(false);
            });
    }, [filters]);

    const setBuzzId = (buzzId: string) => {
        setFilters({ buzzId });
    };

    const clearFilters = () => {
        setFilters({ buzzId: "" });
    };

    const columns = createLookupContentListTableColumns({ onClick });

    return (
        <Grid>
            <GridRow>
                <GridColumn sm={6}>
                    <SearchBox
                        testId="content-lookup-search-buzz-id"
                        placeholder="Buzz Id"
                        onChange={setBuzzId}
                        value={filters.buzzId}
                    />
                </GridColumn>

                <GridColumn sm={6}>
                    <Stack horizontalAlign="end">
                        <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                    </Stack>
                </GridColumn>
            </GridRow>

            <GridRow>
                <GridColumn sm={12} style={{ height: 500, overflowY: "auto" }}>
                    <ListTable
                        columns={columns}
                        items={items}
                        layoutMode="justified"
                        isLoading={isLoadingList}
                        shimmerLines={3}
                        noItemsMessage={
                            !filters.buzzId
                                ? "Search for content by entering a Buzz Id of a content or version."
                                : "Could not match any content with the provided buzz Id."
                        }
                    />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
